import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';

import { MainComponent }   from './components/main/main.component';
import { AuthComponent } from './components/auth/auth.component';
import { AuthGuard } from './auth.guard';

export const AppRoutes: Routes = [{ 
  path: '',
  redirectTo: 'dashboard',
  pathMatch: 'full'
},{
  path: '',
  component: MainComponent, 
  children: [{
    path: 'dashboard',
    loadChildren: './dashboard/dashboard.module#DashboardModule', 
    canActivate: [AuthGuard]
  },{
    path: 'cms',
    loadChildren: './cms/cms.module#CmsModule'
  },{
    path: 'users',
    loadChildren: './users/users.module#UsersModule'
  },{
    path: 'clients',
    loadChildren: './clients/clients.module#ClientsModule'
  },{
    path: 'providers',
    loadChildren: './providers/providers.module#ProvidersModule'
  },{
    path: 'products',
    loadChildren: './products/products.module#ProductsModule'
  },{
    path: 'logistics',
    loadChildren: './logistics/logistics.module#LogisticsModule'
  },{
    path: 'sales',
    loadChildren: './sales/sales.module#SalesModule'
  },{
    path: 'pos',
    loadChildren: './pos/pos.module#PosModule'
  },{
    path: 'trans',
    loadChildren: './transportadora/trans.module#TransModule'
  },{
    path: 'transC',
    loadChildren: './transportadoraCliente/transC.module#TransCModule'
  },{
    path: 'transconta',
    loadChildren: './transconta/transconta.module#TranscontaModule'
  },{
    path: 'marketing',
    loadChildren: './marketing/marketing.module#MarketingModule'
  },{
    path: 'reports',
    loadChildren: './reports/reports.module#ReportsModule'
  },{
    path: 'issue',
    loadChildren: './issue/issue.module#IssueModule'
  },{
    path: 'config',
    loadChildren: './config/config.module#ConfigModule'
  }]
}, {
  path: '',
  component: AuthComponent,
  children: [{
    path: 'auth',
    loadChildren: './components/auth/auth.module#AuthModule'
  },{
    path: 'error',
    loadChildren: './helpers/error/error.module#ErrorModule'
  }]
},{ path: '**', redirectTo: 'dashboard' }];




// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/app-routing.module.ts